"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var CardButton_1 = __importDefault(require("../../Atoms/CardButton/CardButton"));
var Text_1 = __importDefault(require("../../Atoms/Text"));
var RadioGroupContext_1 = __importDefault(require("../../Organisms/RadioGroup/RadioGroupContext"));
var TextField_1 = __importDefault(require("../TextField/TextField"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var browserAndDeviceDetection_1 = require("../../../Helpers/browserAndDeviceDetection");
var deviceSpecificHandlers_1 = require("../../../Helpers/deviceSpecificHandlers");
var makeIconTileRadioButtonStyling_1 = __importDefault(require("./makeIconTileRadioButtonStyling"));
var IconTileRadioButton = function (_a) {
    var Icon = _a.Icon, id = _a.id, isOtherOption = _a.isOtherOption, onClick = _a.onClick, onChange = _a.onChange, onKeyDown = _a.onKeyDown, otherInputError = _a.otherInputError, otherInputValue = _a.otherInputValue, text = _a.text, subtext = _a.subtext, experimentName = _a.experimentName, minHeight = _a.minHeight;
    var _b = (0, react_1.useContext)(RadioGroupContext_1.default), selectedId = _b.selectedId, setSelectedId = _b.setSelectedId;
    var _c = (0, react_1.useState)(false), isFocused = _c[0], setIsFocused = _c[1];
    var _d = (0, react_1.useState)(otherInputValue), otherValue = _d[0], setOtherValue = _d[1];
    var otherInputRef = (0, react_1.useRef)(null);
    var isSubtextPresent = !!subtext;
    var styles = (0, makeIconTileRadioButtonStyling_1.default)({
        isSubtextPresent: isSubtextPresent,
        minHeight: minHeight,
    });
    var isSelected = id === selectedId;
    var isTextfield = (isOtherOption && isFocused) || !!otherValue;
    var handleClick = function () {
        onClick({ id: id });
        if ((0, browserAndDeviceDetection_1.isIOS)() && !otherInputRef.current && isOtherOption) {
            (0, deviceSpecificHandlers_1.iosFocusHandler)(otherInputRef);
        }
        if (otherInputRef.current) {
            otherInputRef.current.focus();
            if (!isSelected && otherValue) {
                setSelectedId(id);
            }
            return;
        }
        setSelectedId(id);
        setIsFocused(true);
    };
    var onOtherTextFieldChange = function (inputChangeEvent) {
        onChange(inputChangeEvent);
        setOtherValue(inputChangeEvent.value);
        if (inputChangeEvent.value) {
            setSelectedId(id);
        }
        else {
            setSelectedId(undefined);
        }
    };
    var handleKeyDown = function (event) {
        if (event) {
            onKeyDown(event);
            if (event.key === 'Enter' && otherInputRef.current) {
                if (!otherValue) {
                    setSelectedId(undefined);
                    setIsFocused(false);
                }
                otherInputRef.current.blur();
            }
        }
    };
    (0, react_1.useEffect)(function () {
        if (isSelected && otherInputRef.current && !(0, browserAndDeviceDetection_1.isIOS)()) {
            otherInputRef.current.focus();
        }
    }, [isSelected]);
    var handleBlur = function () {
        if (!otherValue) {
            setSelectedId(undefined);
        }
        setIsFocused(false);
    };
    var renderTextContent = function () {
        return subtext ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, { variant: "tileItem", experimentName: experimentName, children: text }), (0, jsx_runtime_1.jsx)(Text_1.default, { variant: "tileItemSubtext", experimentName: experimentName, children: subtext })] })) : ((0, jsx_runtime_1.jsx)(Text_1.default, { variant: "tileItem", experimentName: experimentName, children: text }));
    };
    return ((0, jsx_runtime_1.jsx)(CardButton_1.default, { selected: isSelected, "data-selected": isSelected, onClick: handleClick, onKeyDown: handleKeyDown, "data-testid": "radioButtonCardButton", outlined: isSelected, onBlur: handleBlur, experimentName: experimentName, fitContent: isSubtextPresent, children: (0, jsx_runtime_1.jsxs)("div", { css: styles.container, children: [(0, jsx_runtime_1.jsx)("div", { css: styles.icon, children: (0, jsx_runtime_1.jsx)("div", { css: styles.imgDiv, children: Icon }) }), isTextfield ? ((0, jsx_runtime_1.jsx)("div", { css: styles.otherInput, children: (0, jsx_runtime_1.jsx)(TextField_1.default, { "data-testid": "other-option-textfield", id: id, placeholder: text, onClick: handleClick, onChange: onOtherTextFieldChange, isOtherOption: true, inputRef: otherInputRef, errorMessage: otherInputError ? '' : undefined, value: otherInputValue, inputProps: {
                            enterKeyHint: 'go',
                        }, experimentName: experimentName }) })) : (renderTextContent())] }) }));
};
IconTileRadioButton.defaultProps = defaultProps_1.default;
exports.default = IconTileRadioButton;
//# sourceMappingURL=IconTileRadioButton.js.map